import { LwFormMultiSelect } from 'redesign';
import { useFormContext } from 'react-hook-form';
import { Chip, createFilterOptions, styled } from '@mui/material';
import { useCallback } from 'react';
import { PreferredWorkerFormContext } from '../preferred-worker.types';

export type WorkerOption = {
  name: string;
  id: string;
  description?: string;
};

type Props = {
  workerOptions: WorkerOption[];
  index: number;
  disabled?: boolean;
};

export const PreferredWorkerMultiSelect = ({ workerOptions, disabled, index }: Props) => {
  const { control } = useFormContext<PreferredWorkerFormContext>();
  const filterOptions = useCallback(
    createFilterOptions({
      stringify: ({ name, description }: WorkerOption) => `${name} ${description ?? ''}`,
    }),
    []
  );

  return (
    <LwFormMultiSelect
      name={`visibilityRules.${index}.workerOptions`}
      control={control}
      disabled={disabled}
      label="Selecteer de gewenste flexwerker(s)"
      rules={{ required: 'Voer een flexwerker in' }}
      options={workerOptions}
      getOptionKey={(option: WorkerOption) => option.id}
      getOptionLabel={(option: WorkerOption) => option.name}
      renderOption={(props, option) => (
        <Option {...props} key={option.id}>
          <Chip label={option.name}></Chip>
          {option.description ? option.description : null}
        </Option>
      )}
      filterOptions={filterOptions}
      noOptionsText="Aan dit geselecteerde functietype zijn geen partnerrelaties gekoppeld"
    />
  );
};

const Option = styled('li')(({ theme }) => ({
  '.MuiChip-root': {
    backgroundColor: theme.palette.lwPrimaryAccentLight[10],
    marginBottom: 0,
    borderRadius: theme.spacing(6),
  },
  '.MuiChip-label': {
    color: theme.palette.lwPrimaryAccentLight[100],
  },
}));
